import Api, { createFetchErrorMessage } from "utils/api/Api";
import { useQuery } from "@tanstack/react-query";
import { Loading } from "app/components/Loading";

export const ThemeRecommendList = ({ themeId, onChange=f=>f})=>{
    const {data:themeList, isLoading, isError, error} = useQuery({
        queryKey:['recommend/theme/list'],
        queryFn:()=>Api.get('/api/recommend/theme/list'),
        staleTime:1000*60*60*24,
        gcTime:1000*60*60*24,
    });

    if(isLoading)return <Loading />;
    if(isError)return <>{createFetchErrorMessage(error).message}</>
    const itemList = themeList.data?.map( (item)=>{
        return (
            <button className="item" key={item.id} onClick={()=>onChange(item.id)}>{item.title}</button>
        )
    });
    return (
        <div className="recommendList">
            <div className="list">
                {itemList}
            </div>
        </div>
    );
}